import axios from "axios";
import qs from "qs";
const appConfig = require("../../config/config.js");

axios.defaults.timeout = 20000;
axios.interceptors.request.use(
  config =>
    // loading
    config,
  error => Promise.reject(error)
);
axios.interceptors.response.use(
  response => response,
  error => Promise.resolve(error.response)
);

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && response.status === 401) {
    sessionStorage.setItem("token", null);
    return response;
  }

  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: "网络异常"
  };
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  //   if (res.status === -404) {
  //     return res.msg;
  //   } else if (res.data && (!res.data.status)) {
  //     return res.data.msg;
  //   }
  return res;
}

export default {
  post(url, data) {
    const headers = {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    };
    if (sessionStorage.getItem("token")) {
      Object.assign(headers, {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`
      });
    }

    return axios({
      method: "post",
      baseURL: appConfig.BASE_URL,
      url,
      data: qs.stringify(data),
      timeout: 100000000,
      headers
    })
      .then(response => checkStatus(response))
      .then(res => checkCode(res));
  },
  postJson(url, data) {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8"
    };
    if (sessionStorage.getItem("token")) {
      Object.assign(headers, {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`
      });
    }

    return axios({
      method: "post",
      // baseURL: appConfig.BASE_URL,
      url,
      data: data,
      responseType: "json",
      timeout: 100000000,
      headers
    })
      .then(response => checkStatus(response))
      .then(res => checkCode(res));
  },
  get(url, params) {
    const headers = {
      "X-Requested-With": "XMLHttpRequest"
    };
    if (sessionStorage.getItem("token")) {
      Object.assign(headers, {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`
      });
    }
    return axios({
      method: "get",
      baseURL: appConfig.BASE_URL,
      url,
      params, // get 请求时带的参数
      timeout: 100000000,
      headers
    })
      .then(response => checkStatus(response))
      .then(res => checkCode(res));
  },
  put(url, params) {
    const headers = {
      "X-Requested-With": "XMLHttpRequest"
    };
    if (sessionStorage.getItem("token")) {
      Object.assign(headers, {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`
      });
    }
    return axios({
      method: "put",
      baseURL: appConfig.BASE_URL,
      url,
      params, // get 请求时带的参数
      timeout: 100000000,
      headers
    })
      .then(response => checkStatus(response))
      .then(res => checkCode(res));
  }
};



// WEBPACK FOOTER //
// ./src/service/getData.js